import { clone } from './clone';

/**
 * Checks if the window object is available (browser environment).
 */
export function hasWindow(): boolean {
  return typeof window !== 'undefined';
}

/**
 * Reads a value from localStorage with a fallback.
 */
export function readStorage<T>(key: string, fallback: T): T {
  if (!hasWindow()) {
    return clone(fallback);
  }

  try {
    const rawValue = window.localStorage.getItem(key);
    return rawValue ? (JSON.parse(rawValue) as T) : clone(fallback);
  } catch {
    return clone(fallback);
  }
}

/**
 * Writes a value to localStorage and returns it.
 */
export function writeStorage<T>(key: string, value: T): T {
  if (hasWindow()) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  return value;
}

/**
 * Shared storage keys for dev preview.
 */
export const storageKeys = {
  profile: 'DEV_PREVIEW:profile',
  profileCoach: 'DEV_PREVIEW:profile_coach',
  profileLeader: 'DEV_PREVIEW:profile_leader',
  profileNew: 'DEV_PREVIEW:profile_new',
  profileVeteran: 'DEV_PREVIEW:profile_veteran',
  sessions: 'DEV_PREVIEW:sessions',
  tasks: 'DEV_PREVIEW:tasks',
  tasksCoach: 'DEV_PREVIEW:tasks_coach',
  tasksLeader: 'DEV_PREVIEW:tasks_leader',
  tasksNew: 'DEV_PREVIEW:tasks_new',
  tasksVeteran: 'DEV_PREVIEW:tasks_veteran',
  notes: 'DEV_PREVIEW:notes',
  goals: 'DEV_PREVIEW:goals',
  goalsCoach: 'DEV_PREVIEW:goals_coach',
  goalsLeader: 'DEV_PREVIEW:goals_leader',
  goalsNew: 'DEV_PREVIEW:goals_new',
  goalsVeteran: 'DEV_PREVIEW:goals_veteran'
};
